import { httpSuccess, request } from "lib/request"
import { call, put, takeLatest } from "redux-saga/effects"
import { ResponseConfiguration } from "types/payload"
import { GWatcher } from "types/redux"
import { CONFIGURATION_REQUEST, CONFIGURATION_SUCCESS } from "./constant"
import config from "react-global-configuration"
import actions from "./actions"
import {
  PATH,
} from "containers/Survey/models"

import actionsSurvey from "containers/Survey/services/actions"
import { ConfigurationStore } from "types/store"
import { cloneDeep } from "lodash"

async function configurationApi(): Promise<ResponseConfiguration> {
  return await request(config.get("admin.config.route"), {
    method: config.get("admin.config.method"),
  })
}
function* configurationFlow() {
  try {
    const response: ResponseConfiguration = yield call(configurationApi)
    if (httpSuccess(response, "configuration"))
      yield put(actions.success(response.configuration as ConfigurationStore))
    else yield put(actions.error("Aucune configuration trouvée"))
  } catch (e) {
    yield put(actions.error(e as string))
    console.error(e, {
      route: config.get("admin.config.method"),
    })
  }
}

function* configurationWatcher(): GWatcher {
  yield takeLatest(CONFIGURATION_REQUEST, configurationFlow)
}

export default configurationWatcher
